<template>
  <v-data-table
    :value="selected"
    :headers="columns"
    :items="pendingUsers"
    :options.sync="tableOptions"
    :server-items-length="total"
    item-key="id"
    show-select
    :items-per-page="options.itemsPerPage"
    :disable-pagination="loading"
    :footer-props="{
      'disable-pagination': loading,
      ...footerProps,
    }"
    :disable-sort="loading"
    class="elevation-0"
    :loading="loading"
    :search="search"
    no-data-text="No pending applicants found"
    no-results-text="No applicants found in search"
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.displayName`]="{ item }">
      <Typography variant="body-2" as="span" class="word-break">
        {{ getDisplayName(item) }}
      </Typography>

      <br />

      <Typography variant="body-2" as="span" class="mediumGrey--text word-break">
        {{ (item && item.businessEmail) || (item && item.businessPhone) || "" }}
      </Typography>
    </template>

    <template v-slot:[`item.organization`]="{ item }">
      <Typography variant="body-2" as="span" class="word-break">
        {{ (item && item.organization) || "" }}
      </Typography>

      <br />

      <Typography variant="body-2" as="span" class="mediumGrey--text">
        {{ (item && item.jobTitle) || "" }}
      </Typography>
    </template>

    <template v-slot:[`item.createdAt`]="{ item }">
      <Typography variant="body-2" as="span">
        {{ formatDate(item && item.createdAt) }}
      </Typography>
    </template>

    <template v-slot:[`item.data-table-select`]="{ item }">
      <v-simple-checkbox
        color="darkGrey"
        class="py-0 my-0"
        hide-details
        :ripple="false"
        @click.stop="handleCheckboxClick(item)"
        :value="!!selected.find((x) => item && x.id == item.id)"
      />
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <div v-if="canCreateUser" class="d-flex align-center">
        <Button
          icon
          color="success"
          @click.stop="onApproveClick(item)"
          :disabled="loading"
          title="Approve user"
        >
          <v-icon>mdi-check-circle</v-icon>
        </Button>

        <Button
          icon
          color="black"
          @click.stop="onEditClick(item)"
          :disabled="loading"
          title="Edit user"
        >
          <v-icon>mdi-pencil</v-icon>
        </Button>

        <Button
          icon
          color="black"
          @click.stop="onDenyClick(item)"
          :disabled="loading"
          title="Deny user"
        >
          <v-icon>mdi-close</v-icon>
        </Button>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import moment from "moment";
export default {
  name: "PendingUsersDataTable",
  components: { Typography, Button },
  props: {
    selected: { type: Array, default: () => [] },
    pendingUsers: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({}) },
    footerProps: { type: Object, default: () => ({}) },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    search: { type: String, default: "" },
    onApproveClick: { type: Function, default: () => {} },
    onEditClick: { type: Function, default: () => {} },
    onDenyClick: { type: Function, default: () => {} },
    canCreateUser: { type: Boolean, default: true },
  },
  data() {
    return {
      allColumns: [
        { text: "Name/Email or Phone", value: "displayName", sortable: true },
        {
          text: "Organization/Job Title",
          value: "organization",
          sortable: true,
        },
        { text: "Application Date", value: "createdAt", sortable: true },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    columns() {
      if (this.canCreateUser) return this.allColumns;
      return this.allColumns.filter((col) => col.value !== "actions");
    },
    tableOptions: {
      get() {
        return this.options;
      },
      set(value) {
        this.$emit("update:options", value);
      },
    },
  },
  methods: {
    getDisplayName(item) {
      if (!item) return "";
      const firstName = item.firstName || "";
      const lastName = item.lastName || "";
      return `${firstName} ${lastName}`.trim();
    },
    formatDate(dateString) {
      if (!dateString) return "";
      return moment(dateString).format("MM/DD/YYYY, h:mmA");
    },
    handleCheckboxClick(item) {
      this.$emit("checkbox-click", item);
    },
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
}

::v-deep tbody tr td {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
</style>
